export const initBlockData = {
  title: "All Routes",
};

export const initEmptyBlockData = {
  title: "",
};
